import { Media } from "../../Media/Media";
import RichText from "../../RichText";
import type { FolderBlockDoc as FolderBlock } from "../../types/blocks";
import Link from "next/link";

type ItemFromCard = NonNullable<FolderBlock["cards"]>[number]["card"];

export interface Props {
  richText?: ItemFromCard["richText"];
  link?: ItemFromCard["link"];
  media?: ItemFromCard["media"];
}

const CustomCard: React.FC<Props> = (props) => {
  const { richText, link, media } = props;

  return (
    link && (
      <Link
        href={link.url || ""}
        className="w-max h-full flex justify-center justify-items-center "
        target={link.newTab ? "_blank" : "_self"}
      >
        <div className="flex h-full flex-col items-center min-w-[300px] max-w-[300px]">
          {media && typeof media === "object" && (
            <Media
              size="small"
              imgClassName="w-full"
              priority
              resource={media}
            />
          )}
          <div className="w-full h-full xsmall:p-2 md:p-3">
            <div className="group h-full w-full relative">
              {richText && (
                <RichText
                  className="mb-6 text-neutral-950"
                  data={richText}
                  enableGutter={false}
                />
              )}
            </div>
          </div>
        </div>
      </Link>
    )
  );
};

export { CustomCard };
